// extracted by mini-css-extract-plugin
module.exports = {"offers":"_02712f2b3b--offers--q6N2O"};